import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "all", "adults", "heads"]

  connect() {
    this.update()
  }

  update() {
    const option = this.listTarget.selectedOptions[0]

    if (!option?.value) {
      this.reset()
      return
    }

    this.allTarget.textContent = `Start with all ${this.label(option.dataset.allCount, "member")}`
    this.adultsTarget.textContent = `Start with ${this.label(option.dataset.adultsCount, "adult")}`
    this.headsTarget.textContent = `Start with ${this.label(option.dataset.headsCount, "head of household", "heads of household")}`
  }

  reset() {
    this.allTarget.textContent = "Start with all members"
    this.adultsTarget.textContent = "Start with adults"
    this.headsTarget.textContent = "Start with heads of household"
  }

  label(count, singular, plural = `${singular}s`) {
    return `${count} ${count === "1" ? singular : plural}`
  }
}
